import {useLoginInfoStore} from "@/stores/loginInfo";
import LoginUtils from "@/utils/login/LoginUtils";
import ClientCache from "@/utils/login/ClientCache";
import {useErrorsStore} from "@/stores/ToastDataStore";
import Translator from "@/utils/common/Translator";
import ObjectChecker from "@/utils/common/ObjectChecker";

export default class AutoLogoutTime {
    private static registered: boolean = false;

    static registerLoginLogoutEvents() {
        window.addEventListener('storage', async (e: StorageEvent) => {
            let loginInfoStore = useLoginInfoStore();
            let isCurrentLogInInfoValid = loginInfoStore.isLoggedIn;
            if (e.key === 'lastlogintimestamp') {
                if (!isCurrentLogInInfoValid)
                    await LoginUtils.refreshLogin();
            } else if (e.key === 'lastlogouttimestamp') {
                if (isCurrentLogInInfoValid)
                    await LoginUtils.logout();
            }
        });
        // TODO::
        /*
        window.addEventListener('beforeunload', (e) => {
            let presenter = NamaRouterInstance.currentPresenter;
            $(':focus').blur();
            if (presenter && presenter.hasChanges && presenter.hasChanges())
                return "";
        });
        */
    }

    static onActivity() {
        localStorage.setItem("nlsat", ClientCache.currentTimeMillis() + "");
    }

    static registerActivityEvents() {
      const events: (keyof DocumentEventMap)[] = [
        "mousemove",
        "keypress",
        "touchstart",
        "click",
        "scroll",
        "wheel",
      ];
      events.forEach(event => {
        document.addEventListener(event, () => AutoLogoutTime.onActivity(), {passive: true});
      });
      window.addEventListener("message", (e: MessageEvent<any>) => {
        let data = e['message'] ?? e.data;
        if (data === "activityFromReport") {
          AutoLogoutTime.onActivity();
        }
      });
    }

    static registerIfNeeded(info: namaTypes.CurrentLoginInfo) {
        if (this.registered)
            return;
        if (ObjectChecker.isEmptyOrNull(info.autoLogoutTime))
            return;
        if ((ObjectChecker.isNullOrUndefined((info.autoLogoutRememberMe)) || info.autoLogoutRememberMe === false) &&
            localStorage.getItem("rememberme") === "true")
            return;
        localStorage.setItem("nlsat", ClientCache.currentTimeMillis() + "");
        this.registered = true;
        this.registerActivityEvents();
        let t = async function () {
            if (ObjectChecker.isNullOrUndefined(LoginUtils.loginInfo?.userInfo) || ObjectChecker.isEmptyOrNull(LoginUtils.loginInfo?.autoLogoutTime)) {
                AutoLogoutTime.unregisterEvents();
                return false;
            }
            await AutoLogoutTime.logoutIfNoActivity();
            setTimeout(t, 3000);
            return true;
        };
        t();
    }

    private static async logoutIfNoActivity() {
        let nlsat = Number(localStorage.getItem("nlsat"));
        let lastActivityMS = ClientCache.currentTimeMillis() - nlsat || 0;
        if (LoginUtils.loginInfo && LoginUtils.loginInfo.autoLogoutTime && lastActivityMS / 60000 >= LoginUtils.loginInfo.autoLogoutTime) {
            let errorsStore = useErrorsStore();
            errorsStore.pushErrorStr(Translator.translateId("autoLogoutHappened"));
            await LoginUtils.logout();
        }
    }

    private static unregisterEvents() {
        this.registered = false;
        document.removeEventListener(".logouttimer", (e) => AutoLogoutTime.onActivity());
    }
}
